import { SortSearch } from '@shared/interfaces';

export const uuId = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const uniqueArrayItems = (value, index, self) => {
  return self.indexOf(value) === index;
};

export function uniqueArrayObjects(arr, prop) {
  const obj = {};
  return Object.keys(
    arr.reduce((prev, next) => {
      if (!obj[next[prop]]) {
        obj[next[prop]] = next;
      }
      return obj;
    }, obj)
  ).map((i) => obj[i]);
}

export const getRandomInt = (min, max): number => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const normalizeQueryParams = (
  data: any
): { [param: string]: string | string[] } => {
  const params: any = {};
  if (!data) {
    return params;
  }

  for (const key of Object.keys(data)) {
    switch (typeof data[key]) {
      case 'object':
        if (Array.isArray(data[key])) {
          params[key] = data[key].map((e) => `${e}`);
        } else {
          params[key] = JSON.stringify(data[key]);
        }
        break;
      case 'number':
      default:
        params[key] = `${data[key]}`;
    }
  }

  return params;
};

export const applySortSearch = <T>(
  data: T[],
  filter: SortSearch,
  searchKeys?: string[]
): T[] => {
  if (!data || !filter || !data.length) {
    return data;
  }

  return data
    .filter((item) => {
      if (!filter.search || !searchKeys.length) {
        return true;
      }
      const text = searchKeys
        .reduce((prev, curr) => {
          return `${prev} ${(item[curr] || '').trim().toLowerCase()}`;
        }, '')
        .trim();
      return text.includes(filter.search.toLowerCase().trim());
    })
    .sort((a, b) => {
      if (!filter.sort) {
        return 1;
      }
      const key = filter.sort.split('-')[0];
      const desc = filter.sort.split('-')[1];
      const descNum = desc === 'asc' ? 1 : -1;
      return a[key].localeCompare(b[key]) ? 1 * descNum : -1 * descNum;
    });
};

export const hashCode = (str: string) => {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};


export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getCssVars = (): {
  'mobile-top-bar-height': number,
  'mobile-nav-menu-height': number,
  'mobile-padding-top': number
} => {
  const keys = [
    'mobile-top-bar-height',
    'mobile-nav-menu-height',
    'mobile-padding-top'
  ];

  const cssVars: any = {};
  for (const key of keys) {
    const width = document.documentElement.style.getPropertyValue(`--${ key }`);
    if (typeof width === 'string' && Number.isFinite(+width.replace('px', ''))) {
      cssVars[key] = +width.replace('px', '');
    }
  }

  return cssVars;
}

export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getNumberFromString = (str: string): number => {
  if (typeof str !== 'string') { return }

  const val = +str.replace(/\D/g,'');
  return (Number.isFinite(val)) ? val : undefined;
}

export const jsonEqual = (a: Object, b: Object): boolean => {
  return JSON.stringify(a || {}) === JSON.stringify(b || {});
}
